import React from "react";


const Callback = () => {
  return (
    <div className="callback-section">
      <h1>Request a callback?</h1>
      <p>
        Explore how taxNwealth can guide you toward smarter financial
        decisions
      </p>
      <div className="callback-container">
        <div className="callback-image">
          <img
            src="https://d17x24txz4ixmz.cloudfront.net/images/contact-us.webp"
            alt="Callback support illustration"
          />
        </div>
        <div className="callback-form">
          <input type="text" placeholder="Enter your name" />
          <input type="tel" placeholder="Enter your mobile number" />
          <button type="submit">Submit</button>
        </div>
      </div>
    </div>
  );
};

export default Callback;
